<!--<template>-->
<!--</template>-->

<script>
import {
  VTextField,
  VTextarea,
  VSelect,
  VAutocomplete,
  // VCheckbox,
  // VRadioGroup,
  // VRadio,
  VSwitch
  // VSlider,
  // VRangeSlider
} from 'vuetify/lib'
import {LSelectDate} from '../LSelectDate'
import {LSelectDatetime} from '../LSelectDatetime'
import {LSelectTime} from '../LSelectTime'
import {LSelectDuration} from '../LSelectDuration'
import {LSelectWeekday} from '../LSelectWeekday'
import {LSelectFile} from '../LSelectFile'

export default {
  // components: {VTextField},
  name: 'LInput',
  props: [
    'component',
    'config',
    'type',
    'value',
    'prependIcon',
    'label',
    'placeholder',
    'rules',
    'loading',
    'error',
    'errorMessages',
    'singleLine',
    'hideDetails',
    'items',
    'itemKey',
    'itemValue',
    'returnObject',
    'multiple',
    'selectType'
  ],
  data: () => ({
    typeMap: {
      'text': VTextField,
      'textarea': VTextarea,
      'select': VSelect,
      'search': VAutocomplete,
      'date': LSelectDate,
      'time': LSelectTime,
      'datetime': LSelectDatetime,
      'duration': LSelectDuration,
      'weekday': LSelectWeekday,
      'switch': VSwitch,
      'file': LSelectFile
    }
  }),
  render (createElement) {
    let {type, config, ...props} = this.$props
    if (config instanceof Object && config.type) {
      type = config.type
    }
    let inputProps
    if (config instanceof Object) {
      let {type, layout, value, ...t} = config
      inputProps = t
    }
    else {
      inputProps = props
    }
    for (let key of Object.keys(inputProps)) {
      if (inputProps[key] === undefined) {
        delete inputProps[key]
      }
    }
    // console.log('props', inputProps, this.$slots)
    let self = this
    // console.log('inrender', self.value)

    let component = this.config.component || this.component || this.typeMap[type] || VTextField
    return createElement(
      component, // 组件
      {
        props: {
          ...inputProps,
          value: self.value
        },
        attrs: {
          // id: 'foo'
        },
        // domProps: {
        //
        // },
        on: {
          input: function (event) {
            // console.log('linput emit', event)
            self.$emit('input', event)
          }
        }
      }
    )
  },
  created () {
    // console.log('created', this.$props)
  }
}
</script>

<style scoped>

</style>
